import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface UpdateProfilePayload {
  firstName?: string;
  lastName?: string;
  bio?: string;
  website?: string;
  location?: string;
  avatar?: File;
  banner?: File;
}

export interface UpdatePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export interface UpdateEmailPayload {
  newEmail: string;
  password: string;
}

export const usersService = {
  async searchAll(query: string, params: { limit?: number; offset?: number; userType?: 'patron' | 'creator' | 'all' } = {}) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/users/search/all`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      params: { query, limit: 20, offset: 0, userType: 'all', ...params },
    });
    return res.data as {
      users: Array<{
        id: string;
        username: string;
        firstName?: string;
        lastName?: string;
        bio?: string;
        avatar?: string;
        creatorProfile?: any;
        patronAccount?: any;
        _count?: any;
      }>;
      pagination: { total: number; limit: number; offset: number; hasMore: boolean };
    };
  },
  async updateProfile(payload: UpdateProfilePayload) {
    const token = localStorage.getItem('accessToken');
    const formData = new FormData();
    
    if (payload.firstName) formData.append('firstName', payload.firstName);
    if (payload.lastName) formData.append('lastName', payload.lastName);
    if (payload.bio) formData.append('bio', payload.bio);
    if (payload.website) formData.append('website', payload.website);
    if (payload.location) formData.append('location', payload.location);
    if (payload.avatar) formData.append('avatar', payload.avatar);
    if (payload.banner) formData.append('banner', payload.banner);

    const res = await axios.put(`${API_BASE_URL}/api/users/profile`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data as { message: string; user: any };
  },

  async updateBanner(banner: File) {
    const token = localStorage.getItem('accessToken');
    const formData = new FormData();
    formData.append('banner', banner);

    const res = await axios.put(`${API_BASE_URL}/api/users/banner`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data as { message: string; banner: string };
  },

  async updatePassword(payload: UpdatePasswordPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/users/password`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },

  async updateEmail(payload: UpdateEmailPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/users/email`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },

  async deleteAccount() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/users/account`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },

  async getUserStats() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/users/stats/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};

